import React, {Component} from 'react'
import {connect} from 'react-redux'
import autobind from 'autobind-decorator'

import TSelectForm from "../../../common/TSelectForm"
import * as SaveStatus from '../../../../constants/SaveStatus'
import {jsonResponseHandler} from "../../../../utils/FetchHelper"
import {changeBlogVisibility} from '../../../../actions/setting/blog'
import TSubmitButtonForm from "../../../common/TSubmitButtonForm"
import {addPrefix} from "../../../../utils/UriUtil"

@connect(state => ({
  address: state.setting.blog.address,
  visibility: state.setting.blog.info.visibility
}), dispatch => ({
  handleChangeBlogVisibility: (visibility) => {
    dispatch(changeBlogVisibility(visibility))
  }
}))
class BlogStatusForm extends Component {

  constructor(props, context) {
    super(props, context)
    this.state = Object.assign({
      visibility: props.visibility,
      changed: false,
      saveStatus: SaveStatus.READY,
    }, props.address)
  }

  @autobind
  handleChangeVisibility(item) {
    const { visibility } = this.props
    this.setState({
      visibility: item.value,
      changed: visibility !== item.value
    })
  }

  @autobind
  handleSubmit(e) {
    e.preventDefault()

    const {visibility, saveStatus } = this.state
    const {handleChangeBlogVisibility, dispatch} = this.props

    if (saveStatus === SaveStatus.DOING) {
      return
    }

    const data = {
      visibility
    }

    this.setState({
      saveStatus: SaveStatus.DOING
    })
    fetch(addPrefix("/manage/setting/blog/visibility.json"), {
      method: 'post',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(jsonResponseHandler(dispatch))
      .then(() => {
        this.setState({
          saveStatus: SaveStatus.DONE,
          changed: false
        })
        handleChangeBlogVisibility(visibility)
      })
      .catch(e => {
        console.error(e)
        this.setState({
          saveStatus: saveStatus
        })
      })
  }

  render() {
    const { primaryDomain, useSecureProtocol } = this.props.address
    const { visibility, changed, saveStatus} = this.state

    let status = saveStatus
    if (saveStatus !== SaveStatus.DOING && changed) {
      status = SaveStatus.CAN_SUBMIT
    }

    const protocol = useSecureProtocol ? 'https' : 'http'

    return (
      <form className="wrap_set" onSubmit={this.handleSubmit}>
        <fieldset className="fld_address1">
          <legend className="screen_out">기본주소</legend>
          <div className="item_set">
            <span className="txt_item">기본 주소</span> <em className="txt_emph">{protocol}://{primaryDomain}</em>
            {/*<a href="https://notice.tistory.com/2470" className="link_domain" target="_blank">*/}
            {/*  보안접속 중<span className="ico_blog ico_question"/>*/}
            {/*</a>*/}
          </div>
        </fieldset>
        <fieldset className="fld_address3">
          <legend className="screen_out">블로그 공개 설정</legend>
          <div className="item_set">
            블로그를
            <TSelectForm className="opt_set opt_address2" items={[
              {label: '모두에게 공개합니다.', value: 'public'},
              {label: '친구에게만 공개합니다.', value: 'connected'},
              {label: '공개하지 않습니다.', value: 'private'}
            ]} selected={visibility} onSelect={this.handleChangeVisibility}/>
          </div>
        </fieldset>
        <fieldset>
          <legend className="screen_out">저장 버튼</legend>
          <TSubmitButtonForm type="submit" status={status}/>
        </fieldset>
      </form>
    )
  }
}

export default BlogStatusForm
